module.exports = __webpack_public_path__ + "img/style3.40c7e6ba.png";